import React, { useState } from 'react'
import styles from './ParentLineWrapper.module.scss'
import { Props } from './types'
import cl from 'classnames'

const ParentLineWrapperComponent = (props: Props) => {
  const { children } = props

  const [showFrame, setShowFrame] = useState(false)

  const toggleShowFrame = () => {
    setShowFrame(state => !state)
  }

  return (
    <div className={cl(styles.container, { [styles.frame]: showFrame })}>
      {children(toggleShowFrame)}
    </div>
  )
}

const ParentLineWrapper = ParentLineWrapperComponent
export { ParentLineWrapper }
